import { ButtonListImports } from './ButtonList';

export const learnMoreToButtonList = (node): ButtonListImports => {
    const buttons = [];

    for (const name of node.field_category_buttons) {
        const button = {
            text: name,
            uri: ``,
        };

        if (name.toLowerCase().includes(`newsroom`)) {
            button.uri = `https://corporate.charter.com/newsroom`;
        } else if (name.toLowerCase().includes(`investor`)) {
            button.uri = `https://ir.charter.com/investor-overview`;
        } else if (name.toLowerCase().includes(`community`)) {
            button.uri = `https://corporate.charter.com/community-impact`;
        }

        buttons.push(button);
    }

    return {
        title: node.field_title,
        buttons,
    };
};
